<footer
  class="relative border-t border-[var(--mat-sys-primary)] bg-[var(--mat-sys-primary)] dark:border-slate-800 not-prose">
  <div class="relative max-w-7xl mx-auto px-4 sm:px-6 dark:text-slate-300">
    <div class="grid grid-cols-12 gap-4 gap-y-8 sm:gap-8 py-8 md:py-12">
      <!-- SITE MAIN DATA -->
      <div class="col-span-12 lg:col-span-4">
        <div class="mb-2 flex flex-col justify-items-end">
          <!-- NAME -->
          <a class="text-white inline-block font-bold text-xl" routerLink="/">
            {{ siteInfo().name }}
          </a>
          <!-- SLOGAN -->
          <span class="text-white mt-2">{{ siteInfo().slogan }}</span>
          <!-- LOGO -->
          @if (siteInfo().logo) {
            <img
              [src]="siteInfo().logo"
              [alt]="siteInfo().name + ' logo'"
              [width]="120"
              [height]="120"
              class="mt-2" />
          }
          @let help = helpButton();
          @if (help.show) {
            <edt-whatsapp-link-button
              [phoneNumber]="help.phoneNumber"
              [message]="help.message ?? null"
              [label]="help.label ?? '¿Necesitas ayuda?'"
              [svgIcon]="help.icon ?? null">
            </edt-whatsapp-link-button>
          }
        </div>
        <!-- SECONDARY LINKS -->
        <div class="text-sm">
          @for (link of secondaryLinks(); track link) {
            <a
              class="text-muted transition duration-150 ease-in-out mr-2 rtl:mr-0 rtl:ml-2"
              [ngClass]="linkStyles()"
              [routerLink]="link.href"
              [innerHTML]="link.text">
            </a>
          }
        </div>
      </div>

      <!-- LINKS COLLECTIONS -->
      @for (linkCollection of links(); track linkCollection) {
        <div class="col-span-12 sm:col-span-6 md:col-span-3 lg:col-span-2">
          <div class="font-medium mb-2" [ngClass]="headerStyles()">
            {{ linkCollection.title }}
          </div>
          <ul class="text-sm">
            @for (link of linkCollection.links; track link) {
              <li class="mb-2">
                @if (link.icon) {
                  <mat-icon
                    class="align-middle mr-1 rtl:ml-1 rtl:mr-0 text-[var(--mat-sys-on-primary)]"
                    [svgIcon]="link.icon"></mat-icon>
                }
                @if (link.no_follow) {
                  <span
                    class="text-muted transition duration-150 ease-in-out cursor-default"
                    [ngClass]="linkStyles()"
                    [innerHTML]="link.text">
                  </span>
                } @else {
                  @if (link.href | isExternalUrl) {
                    <a
                      class="text-muted transition duration-150 ease-in-out"
                      [ngClass]="linkStyles()"
                      [href]="link.href"
                      target="_blank"
                      [innerHTML]="link.text">
                    </a>
                  } @else {
                    <a
                      class="text-muted transition duration-150 ease-in-out"
                      [ngClass]="linkStyles()"
                      [routerLink]="link.href"
                      [innerHTML]="link.text">
                    </a>
                  }
                }
              </li>
            }
          </ul>
        </div>
      }
    </div>
    <div class="md:flex md:items-center md:justify-between py-6 md:py-8">
      <!-- SOCIAL LINKS -->
      @if (socialLinks().length > 0) {
        <ul
          class="flex mb-4 md:order-1 -ml-2 md:ml-4 md:mb-0 rtl:ml-0 rtl:-mr-2 rtl:md:ml-0 rtl:md:mr-4">
          @for (link of socialLinks(); track link) {
            <li>
              <a
                class="text-muted dark:text-gray-400 dark:focus:ring-gray-700 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 hover:bg-gray-100 inline-flex items-center p-2.5 rounded-lg text-sm"
                [ngClass]="socialStyle()"
                [attr.aria-label]="link.ariaLabel"
                [href]="link.href"
                target="_blank">
                @switch (link.type) {
                  @case ('SVG_NAME_REGISTER') {
                    <mat-icon [svgIcon]="link.icon"></mat-icon>
                  }
                  @case ('SVG_ELEMENT') {
                    <div [innerHTML]="link.icon | safehtml"></div>
                  }
                  @case ('SVG_PATH') {
                    <edt-svg [path]="link.icon"></edt-svg>
                  }
                  @default {
                    <div [innerHTML]="link.icon | safehtml"></div>
                  }
                }
              </a>
            </li>
          }
        </ul>
      }

      <!-- FOOT NOTE -->
      <div
        class="text-sm mr-4 dark:text-slate-400"
        [ngClass]="footNoteStyle()"
        [innerHTML]="footNote()"></div>
    </div>
  </div>
</footer>
